<template>
  <section class="videos-section">
    <HeadingSlim class="mb-10">Videos</HeadingSlim>
    <VideoGrid v-if="videos" :videos="videos" />
  </section>
</template>

<script lang="ts" setup>
import type { Video } from '~/types/videos';
defineProps<{
  videos: Video[];
}>();
</script>
